import { Header } from "semantic-ui-react";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "mdbreact";
// import {Button} from 'react-materialize'
import { Table, Container } from "semantic-ui-react";
import { Form, Checkbox } from "semantic-ui-react";

import React, { Component } from "react";
import { TextArea } from "semantic-ui-react";
import domain from "../../../../../domain.js";
// import 'semantic-ui-css/semantic.min.css';
import axios from "axios";

const colors = ["violet"];
// let flag=false;
export default class SessionWiseFeedbackModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedback: {
        clarity: "5",
        objective: "5",
        learning: "5",
        faculty: "5",
        demonstration: "5",
        coursematerial: "5",
        overall: "5",
        comment: "",
      },
      flag1: false,

      modal: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeo = this.handleChangeo.bind(this);
    this.handleChangel = this.handleChangel.bind(this);
    this.handleChangef = this.handleChangef.bind(this);
    this.handleChangd = this.handleChanged.bind(this);
    this.handleChangec = this.handleChangec.bind(this);
    this.handleChangeol = this.handleChangeol.bind(this);
    this.handleChangecomment = this.handleChangecomment.bind(this);
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  handleChangecomment = (e) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.comment = e.target.value;

    this.setState({
      feedback,
    });
  };

  handleChange = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.clarity = value;
    this.setState({
      feedback,
    });
  };
  handleChangeo = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.objective = value;
    this.setState({
      feedback,
    });
  };
  handleChangel = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.learning = value;
    this.setState({
      feedback,
    });
  };
  handleChangef = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.faculty = value;
    this.setState({
      feedback,
    });
  };
  handleChanged = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.demonstration = value;
    this.setState({
      feedback,
    });
  };
  handleChangec = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.coursematerial = value;
    this.setState({
      feedback,
    });
  };
  handleChangeol = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.overall = value;
    this.setState({
      feedback,
    });
  };

  saveFeedbackTopicWise(feedback) {
    console.log("inserting");
  }
  updateFeedbackTopicWise(feedback) {
    console.log("updating ");

    axios
      .request({
        method: "PUT",
        url: `${domain.DBServer}/update-session-feedback`,
        data: feedback,
      })
      .then((result) => {
        if (result.data.success) {
          //   console.log(result.data.result)
          //   console.log(parseInt(result.data.result.submission_count))
          //   console.log(this.props)
          alert(result.data.msg);

          //.push(`/feedbackMenu/sessionwise/${result.data.result.trainee_id}`)//window.location.reload();
          this.props.updateSubmissionCount(
            parseInt(result.data.result.submission_count, 10)
          );
        }
      })
      .catch((error) => console.log(error));
  }

  checkFeedbackTopicWiseAvailability() {
    const data = {
      trainee_id: this.props.trainee_id,
      course_session_id: this.props.course_session_id,
    };
    // console.log(this.props.course_session_id)
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/check-course-session-feedback`,
        data: data,
      })
      .then((result) => {
        //  console.log(result.data)
        if (result.data.success) {
          let feedback = { ...this.state.feedback };
          feedback.clarity = result.data.output.feedback.clarity;
          feedback.objective = result.data.output.feedback.objective;
          feedback.comment = result.data.output.feedback.comment;
          feedback.learning = result.data.output.feedback.learning;
          feedback.faculty = result.data.output.feedback.faculty;
          feedback.demonstration = result.data.output.feedback.demonstration;
          feedback.coursematerial = result.data.output.feedback.coursematerial;
          feedback.overall = result.data.output.feedback.overall;

          this.setState({
            feedback,
          });

          this.props.updateSubmissionCount(
            parseInt(result.data.submission_count, 10)
          );
          // flag=true
          // this.setState({
          //    flag1:true
          // })
        }
        // else
        // {
        //   // flag=false
        //   this.setState({
        //      flag1:false
        //   })
        // }
      })
      .catch((error) => console.log(error));
  }

  onSubmit = (e) => {
    e.preventDefault();

    const feedback_course_session_wise = {
      feedback: {
        clarity: this.state.feedback.clarity,
        objective: this.state.feedback.objective,
        learning: this.state.feedback.learning,
        faculty: this.state.feedback.faculty,
        demonstration: this.state.feedback.demonstration,
        coursematerial: this.state.feedback.coursematerial,
        overall: this.state.feedback.overall,
        comment: this.state.feedback.comment,
      },
      course_session_id: this.props.course_session_id,
      trainee_id: this.props.trainee_id,
      submission_count: parseInt(this.props.submission_count, 10) + 1,
    };

    if (this.props.submission_count === 0) {
      console.log("in save");
      axios
        .request({
          method: "post",
          url: `${domain.DBServer}/save-course-session-feedback`,
          data: feedback_course_session_wise,
        })
        .then((result) => {
          if (result.data.success) {
            this.props.updateSubmissionCount(
              parseInt(result.data.result.submission_count, 10)
            );

            alert(result.data.msg);
            // alert('Feedback successfully submitted')
            window.location.reload();
            // window.location.reload();
          } else {
            this.setState({
              flag1: true,
            });
          }
        })
        .catch((error) => console.log(error));
    }

    // console.log(this.state.flag1)
    // if(this.state.flag1)
    // {
    //     console.log('in update')
    //    this.updateFeedbackTopicWise(feedback_course_session_wise)
    //    window.location.reload();
    // }
    // else
    // {
    //   console.log('in save')
    //   this.saveFeedbackTopicWise(feedback_course_session_wise)
    //   window.location.reload();
    // }
  };

  componentDidMount() {
    this.checkFeedbackTopicWiseAvailability();
  }

  render() {
    console.log(this.props.submission_count);
    return (
      // <Modal.Content>
      // <Modal.Description>
      <div>
        <Button color="primary" onClick={this.toggle}>
          Feedback
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
          <ModalHeader toggle={this.toggle}></ModalHeader>
          <ModalBody>
            <Form
              className="attached fluid segment"
              onSubmit={this.onSubmit}
              style={{ fontFamily: "Helvetica" }}
            >
              <Header as="h3" textAlign="center" color="violet">
                Feedback Proforma
              </Header>
              <Header as="h4" textAlign="center" color="violet">
                {this.props.session.lecturer_name}
              </Header>
              <Header as="h4" textAlign="center" color="violet">
                {this.props.session.title}
              </Header>
              <Container textAlign="left">
                <p> Rate the following in the scale of 1 to 5 </p>
                <p style={{ textAlign: "right" }}>
                  (5- Excellent, 4- VeryGood, 3- Good, 2- Just Fair, 1- Poor)
                </p>
              </Container>
              {colors.map((color) => (
                <Table color={color} key={color}>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell width="5"></Table.HeaderCell>
                      <Table.HeaderCell width={1}>5</Table.HeaderCell>
                      <Table.HeaderCell width={1}>4</Table.HeaderCell>
                      <Table.HeaderCell width={1}>3</Table.HeaderCell>
                      <Table.HeaderCell width={1}>2</Table.HeaderCell>
                      <Table.HeaderCell width={1}>1</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>Clarity of Session Objective</Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="clarity"
                              value="5"
                              checked={this.state.feedback.clarity === "5"}
                              onChange={this.handleChange}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="clarity"
                              value="5"
                              checked={this.state.feedback.clarity === "5"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="clarity"
                              value="4"
                              checked={this.state.feedback.clarity === "4"}
                              onChange={this.handleChange}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="clarity"
                              value="4"
                              checked={this.state.feedback.clarity === "4"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="clarity"
                              value="3"
                              checked={this.state.feedback.clarity === "3"}
                              onChange={this.handleChange}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="clarity"
                              value="3"
                              checked={this.state.feedback.clarity === "3"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="clarity"
                              value="2"
                              checked={this.state.feedback.clarity === "2"}
                              onChange={this.handleChange}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="clarity"
                              value="2"
                              checked={this.state.feedback.clarity === "2"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="clarity"
                              value="1"
                              checked={this.state.feedback.clarity === "1"}
                              onChange={this.handleChange}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="clarity"
                              value="1"
                              checked={this.state.feedback.clarity === "1"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>Whether Objective met</Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="objective"
                              value="5"
                              checked={this.state.feedback.objective === "5"}
                              onChange={this.handleChangeo}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="objective"
                              value="5"
                              checked={this.state.feedback.objective === "5"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="objective"
                              value="4"
                              checked={this.state.feedback.objective === "4"}
                              onChange={this.handleChangeo}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="objective"
                              value="4"
                              checked={this.state.feedback.objective === "4"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="objective"
                              value="3"
                              checked={this.state.feedback.objective === "3"}
                              onChange={this.handleChangeo}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="objective"
                              value="3"
                              checked={this.state.feedback.objective === "3"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="objective"
                              value="2"
                              checked={this.state.feedback.objective === "2"}
                              onChange={this.handleChangeo}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="objective"
                              value="2"
                              checked={this.state.feedback.objective === "2"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="objective"
                              value="1"
                              checked={this.state.feedback.objective === "1"}
                              onChange={this.handleChangeo}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="objective"
                              value="1"
                              checked={this.state.feedback.objective === "1"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>Learning New Concepts</Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="learning"
                              value="5"
                              checked={this.state.feedback.learning === "5"}
                              onChange={this.handleChangel}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="learning"
                              value="5"
                              checked={this.state.feedback.learning === "5"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="learning"
                              value="4"
                              checked={this.state.feedback.learning === "4"}
                              onChange={this.handleChangel}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="learning"
                              value="4"
                              checked={this.state.feedback.learning === "4"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="learning"
                              value="3"
                              checked={this.state.feedback.learning === "3"}
                              onChange={this.handleChangel}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="learning"
                              value="3"
                              checked={this.state.feedback.learning === "3"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="learning"
                              value="2"
                              checked={this.state.feedback.learning === "2"}
                              onChange={this.handleChangel}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="learning"
                              value="2"
                              checked={this.state.feedback.learning === "2"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="learning"
                              value="1"
                              checked={this.state.feedback.learning === "1"}
                              onChange={this.handleChangel}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="learning"
                              value="1"
                              checked={this.state.feedback.learning === "1"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>Faculty Presentation Skills</Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="faculty"
                              value="5"
                              checked={this.state.feedback.faculty === "5"}
                              onChange={this.handleChangef}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="faculty"
                              value="5"
                              checked={this.state.feedback.faculty === "5"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="faculty"
                              value="4"
                              checked={this.state.feedback.faculty === "4"}
                              onChange={this.handleChangef}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="faculty"
                              value="4"
                              checked={this.state.feedback.faculty === "4"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="faculty"
                              value="3"
                              checked={this.state.feedback.faculty === "3"}
                              onChange={this.handleChangef}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="faculty"
                              value="3"
                              checked={this.state.feedback.faculty === "3"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="faculty"
                              value="2"
                              checked={this.state.feedback.faculty === "2"}
                              onChange={this.handleChangef}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="faculty"
                              value="2"
                              checked={this.state.feedback.faculty === "2"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="faculty"
                              value="1"
                              checked={this.state.feedback.faculty === "1"}
                              onChange={this.handleChangef}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="faculty"
                              value="1"
                              checked={this.state.feedback.faculty === "1"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        Usefulness of Presentation Material/ Practical Handouts
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="5"
                              checked={
                                this.state.feedback.demonstration === "5"
                              }
                              onChange={this.handleChanged}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="5"
                              checked={
                                this.state.feedback.demonstration === "5"
                              }
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="4"
                              checked={
                                this.state.feedback.demonstration === "4"
                              }
                              onChange={this.handleChanged}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="4"
                              checked={
                                this.state.feedback.demonstration === "4"
                              }
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="3"
                              checked={
                                this.state.feedback.demonstration === "3"
                              }
                              onChange={this.handleChanged}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="3"
                              checked={
                                this.state.feedback.demonstration === "3"
                              }
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="2"
                              checked={
                                this.state.feedback.demonstration === "2"
                              }
                              onChange={this.handleChanged}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="2"
                              checked={
                                this.state.feedback.demonstration === "2"
                              }
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="1"
                              checked={
                                this.state.feedback.demonstration === "1"
                              }
                              onChange={this.handleChanged}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="demonstration"
                              value="1"
                              checked={
                                this.state.feedback.demonstration === "1"
                              }
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                    </Table.Row>

                    {/* <Table.Row>
            <Table.Cell>Usefulness of Course Material</Table.Cell>
            <Table.Cell>
            <Form.Field>
            {this.props.submission_count===0?<Checkbox radio
            name='coursematerial'
            value='5'
            checked={this.state.feedback.coursematerial === '5'}
            onChange={this.handleChangec}
          />:<Checkbox radio
          name='coursematerial'
          value='5'
          checked={this.state.feedback.coursematerial === '5'}
          
        />}
          </Form.Field>
          </Table.Cell>
          <Table.Cell>
          <Form.Field>
          {this.props.submission_count===0?<Checkbox radio
            name='coursematerial'
            value='4'
            checked={this.state.feedback.coursematerial === '4'}
            onChange={this.handleChangec}
          />:<Checkbox radio
            name='coursematerial'
            value='4'
            checked={this.state.feedback.coursematerial === '4'}
            
          />}
          </Form.Field>
          </Table.Cell>
          <Table.Cell>
          <Form.Field>
          {this.props.submission_count===0?<Checkbox radio
            name='coursematerial'
            value='3'
            checked={this.state.feedback.coursematerial === '3'}
            onChange={this.handleChangec}
          />:<Checkbox radio
            name='coursematerial'
            value='3'
            checked={this.state.feedback.coursematerial === '3'}
            
          />}
          </Form.Field>
          </Table.Cell>
          <Table.Cell>
          <Form.Field>
          {this.props.submission_count===0?<Checkbox radio
            name='coursematerial'
            value='2'
            checked={this.state.feedback.coursematerial === '2'}
            onChange={this.handleChangec}
          />:<Checkbox radio
            name='coursematerial'
            value='2'
            checked={this.state.feedback.coursematerial === '2'}
            
          />}
          </Form.Field>
          </Table.Cell>
          <Table.Cell>
          <Form.Field>
          {this.props.submission_count===0?<Checkbox radio
            name='coursematerial'
            value='1'
            checked={this.state.feedback.coursematerial === '1'}
            onChange={this.handleChangec}
          />:<Checkbox radio
            name='coursematerial'
            value='1'
            checked={this.state.feedback.coursematerial === '1'}
            
          />}
          </Form.Field>
          </Table.Cell>
          </Table.Row> */}

                    <Table.Row>
                      <Table.Cell>Overall Session evaluation</Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="overall"
                              value="5"
                              checked={this.state.feedback.overall === "5"}
                              onChange={this.handleChangeol}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="overall"
                              value="5"
                              checked={this.state.feedback.overall === "5"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="overall"
                              value="4"
                              checked={this.state.feedback.overall === "4"}
                              onChange={this.handleChangeol}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="overall"
                              value="4"
                              checked={this.state.feedback.overall === "4"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="overall"
                              value="3"
                              checked={this.state.feedback.overall === "3"}
                              onChange={this.handleChangeol}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="overall"
                              value="3"
                              checked={this.state.feedback.overall === "3"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="overall"
                              value="2"
                              checked={this.state.feedback.overall === "2"}
                              onChange={this.handleChangeol}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="overall"
                              value="2"
                              checked={this.state.feedback.overall === "2"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                      <Table.Cell>
                        <Form.Field>
                          {this.props.submission_count === 0 ? (
                            <Checkbox
                              radio
                              name="overall"
                              value="1"
                              checked={this.state.feedback.overall === "1"}
                              onChange={this.handleChangeol}
                            />
                          ) : (
                            <Checkbox
                              radio
                              name="overall"
                              value="1"
                              checked={this.state.feedback.overall === "1"}
                            />
                          )}
                        </Form.Field>
                      </Table.Cell>
                    </Table.Row>

                    {/* <Button type='submit' onClick={this.saveAndContinue}>Save & Submit</Button> */}
                  </Table.Body>
                </Table>
              ))}
              Any other comments
              {this.props.submission_count === 0 ? (
                <TextArea
                  cols="15"
                  placeholder="Any other comments"
                  name="comment"
                  value={this.state.feedback.comment}
                  onChange={this.handleChangecomment}
                />
              ) : (
                <TextArea
                  cols="15"
                  placeholder="Any other comments"
                  name="comment"
                  value={this.state.feedback.comment}
                  onChange={this.handleChangecomment}
                  disabled
                />
              )}
              <br />
              <div className="alert alert-danger" role="alert">
                <b>
                  please note that feedback once submitted cannot be modified
                </b>
              </div>
              {this.props.submission_count === 0 ? (
                <Button
                  color="blue"
                  type="submit"
                  name="save"
                  onClick={this.save}
                >
                  Submit
                </Button>
              ) : (
                <Button
                  color="blue"
                  type="submit"
                  name="save"
                  onClick={this.onSubmit}
                  disabled
                >
                  Submit
                </Button>
              )}
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggle}>
              Close
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
